<template>
  <div class="youtube-player">
    <youtube :resize="true" :video-id="currentVidId" ref="youtube" />
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "YouTubePlayer",
  computed: {
    currentVidId() {
      return this.$store.state.volatile.currentVidId;
    },
    player() {
      return this.$refs.youtube.player;
    },
    time() {
      return this.$refs.youtube.player.getDuration();
    }
  },
  methods: {
    getTime() {
      this.$store.dispatch("setVidLength", this.time).then(() => {
        this.$store.dispatch("setInitialCuepoints", this.currentVidId);
      }); // Send Promise to store
    },
    setCuePoint(note) {
      // Send Promise with current time to store
      this.$store.dispatch("setCuePoint", {
        time: this.$refs.youtube.player.getCurrentTime(),
        note: note
      });
    },
    goTo(note) {
      this.player.seekTo(this.$store.getters.cuePoint(note));
    },
    play() {
      this.player.seekTo();
    },
    stop() {
      this.player.stopVideo();
    }
  },
  mounted() {
    EventBus.$on("SET_CUEPOINT", note => {
      this.setCuePoint(note);
    });
    EventBus.$on("YT_GOTO", note => {
      this.goTo(note);
    });
    EventBus.$on("YT_PLAY", () => {
      this.play();
    });
    EventBus.$on("YT_STOP", () => {
      this.stop();
    });
    EventBus.$on("YT_GET_LENGTH", () => {
      this.getTime();
    });
  },
  // Remove all EventBus listeners
  beforeDestroy() {
    EventBus.$off("SET_CUEPOINT");
    EventBus.$off("YT_GOTO");
    EventBus.$off("YT_PLAY");
    EventBus.$off("YT_STOP");
    EventBus.$off("YT_GET_LENGTH");
  }
};
</script>

<style lang="scss">
.youtube-player {
  margin: 15px 0;
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
